<ng-container *ngIf="!(isPartOfArNavigation$ | async)">
    <div class="alert alert-danger">
        {{ 'aumico_reports_page_is_not_part_of_ar_navigation' | i18next }}
    </div>
</ng-container>
<ng-container *ngIf="isPartOfArNavigation$ | async" content>
    <aumico-annualReport-financial-statement-import-form-page
        *ngIf="activeAnnualReport != null"
        (importFormCompleted)="onImportFormCompletion($event)"
        (fileChanged)="onAuditFileChange($event)"
        (accountsToMap)="onAccountsToMap($event)"
        (extraExcelContentChanged)="onExtraExcelContentChanged($event)"
        [balanceFinancialStatementSource]="financialStatementSource?.balance"
        [incomeFinancialStatementSource]="financialStatementSource?.income"
        (balanceFinancialStatementSourceOutput)="onBalanceFinancialStatementSourceChange($event)"
        (incomeFinancialStatementSourceOutput)="onIncomeFinancialStatementSourceChange($event)"
        (importedTaxonomyConstructed)="onImportedTaxonomyConstructed($event)"
        (datevSpreadSheetWithErrors)="onDatevSpreadSheetWithErrors($event)"
        [autoFillApplied]="isAutoFillApplied"
        (selectedAnnualReportWithAutofillOptions)="onSelectAnnualReportForUploadAndMappingAutoFill($event)"
        [noPreviousYearData]="noPreviousYearData"
        [isPreviousYearDataTakenFromPreviousBalanceAnnualReport]="
            isPreviousYearDataTakenFromPreviousBalanceAnnualReport
        "
        [isPreviousYearDataTakenFromPreviousIncomeAnnualReport]="isPreviousYearDataTakenFromPreviousIncomeAnnualReport"
        [previousBalanceAccounts]="previousBalanceAccounts"
        [previousIncomeAccounts]="previousIncomeAccounts"
        [previousBalanceSwitchAccounts]="previousBalanceSwitchAccounts"
        [activeAnnualReportId]="activeAnnualReportEncryptedId"
        [selectedAccountingBasisId]="selectedAccountingBasisId"
        [autofillOptions]="activeAnnualReport?.templateReportAutofillOptions"
        [reportLocale]="reportLocale"
        [userLanguage]="userLanguage"
        [selectedCompanyLegalFormId]="selectedCompanyLegalFormId"
        [uploadAndMappingAutoFillAnnualReportIdExist]="uploadAndMappingAutoFillAnnualReportIdExist"
        [uploadAndMappingAutoFillAnnualReportToggleDisabled]="uploadAndMappingAutoFillAnnualReportToggleDisabled"
        [showShareholderInformation]="showShareholderInformation"
        [aiDelegate]="aiDelegate"
    ></aumico-annualReport-financial-statement-import-form-page>

    <div *ngIf="activeAnnualReport != null" class="import-integrations">
        <div class="or-line">
            <span class="grey line"></span>
            <p class="import-integrations__or">{{ 'aumico_annual_report_general_information_optional_or' | i18next }}</p>
            <span class="grey line"></span>
        </div>
        <div class="import-integrations__cards">
            <aumico-integration-sync-card
                *ngIf="showBexioCard"
                name="Bexio"
                [description]="'aumico_companies_integrations_bexio_description' | i18next"
                logoSrc="/assets/hamIcons/bexio-logo.svg"
                bannerBgColor="#e8f5f2"
                [connectionStatus]="bexioConnectionStatus$ | async"
                [syncMode]="true"
                [lastSyncAt]="activeAnnualReport?.integrations?.bexio?.lastSyncedAt"
                [noMatchingYear]="bexioNoMatchingYear"
                (connectClicked)="onBexioConnect()"
                (syncDataClicked)="onBexioSyncData()"
            ></aumico-integration-sync-card>
            <aumico-integration-sync-card
                *ngIf="showD365bcCard"
                name="Dynamics 365 Business Central"
                [description]="'aumico_integration_d365bc_description' | i18next"
                logoSrc="/assets/hamIcons/d365bc-logo.svg"
                bannerBgColor="#e6eef8"
                [connectionStatus]="d365bcCardStatus"
                [syncMode]="true"
                [lastSyncAt]="activeAnnualReport?.integrations?.d365bc?.lastSyncedAt"
                [noMatchingYear]="d365bcNoMatchingYear"
                (connectClicked)="onD365bcConnect()"
                (syncDataClicked)="onD365bcSyncData()"
            ></aumico-integration-sync-card>
            <aumico-integration-sync-card
                *ngIf="showAbacusCard"
                name="Abacus"
                [description]="'aumico_integration_abacus_description' | i18next"
                logoSrc="/assets/hamIcons/generic-integration-logo.svg"
                bannerBgColor="#f3f4f6"
                [connectionStatus]="abacusCardStatus"
                [syncMode]="true"
                [lastSyncAt]="activeAnnualReport?.integrations?.abacus?.lastSyncedAt"
                [noMatchingYear]="false"
                (connectClicked)="onAbacusConnect()"
                (syncDataClicked)="onAbacusSyncData()"
            ></aumico-integration-sync-card>
            <aumico-integration-sync-card
                *ngIf="showTopalCard"
                data-testid="topal-sync-card"
                name="Topal"
                [description]="'aumico_integration_topal_description' | i18next"
                logoSrc="/assets/hamIcons/topal-logo.png"
                bannerBgColor="#ffffff"
                [connectionStatus]="topalCardStatus"
                [syncMode]="true"
                [lastSyncAt]="activeAnnualReport?.integrations?.topal?.lastSyncedAt"
                [noMatchingYear]="false"
                (connectClicked)="onTopalConnect()"
                (syncDataClicked)="onTopalSyncData()"
            ></aumico-integration-sync-card>
            <aumico-integration-sync-card
                *ngIf="showAccountoCard"
                data-testid="accounto-sync-card"
                name="Accounto"
                [description]="'aumico_integration_accounto_description' | i18next"
                logoSrc="/assets/hamIcons/accounto-logo.png"
                bannerBgColor="#1c2236"
                [connectionStatus]="accountoCardStatus"
                [syncMode]="true"
                [lastSyncAt]="accountoLastSyncedAt"
                [noMatchingYear]="false"
                (connectClicked)="onAccountoConnect()"
                (syncDataClicked)="onAccountoSyncData()"
            ></aumico-integration-sync-card>
            <aumico-integration-sync-card
                *ngIf="showProffixCard"
                data-testid="proffix-sync-card"
                name="PROFFIX"
                [description]="'aumico_integration_proffix_description' | i18next"
                logoSrc="/assets/hamIcons/proffix-logo.png"
                bannerBgColor="#ffffff"
                [connectionStatus]="proffixCardStatus"
                [syncMode]="true"
                [lastSyncAt]="proffixLastSyncedAt"
                [noMatchingYear]="false"
                (connectClicked)="onProffixConnect()"
                (syncDataClicked)="onProffixSyncData()"
            ></aumico-integration-sync-card>
            <aumico-integration-card-coming-soon
                *ngIf="showComingSoonCard"
                [name]="'aumico_companies_integrations_placeholder_name' | i18next"
                [description]="'aumico_companies_integrations_placeholder_description' | i18next"
                [isPlaceholder]="true"
                bannerBgColor="#f3f4f6"
                (requestClicked)="onIntegrationRequestClicked()"
            ></aumico-integration-card-coming-soon>
        </div>
    </div>

    <div *ngIf="activeAnnualReport == null" class="alert alert-danger">
        {{ 'aumico_reports_required_data_not_completed' | i18next }}
    </div>

    <!-- Bexio import loading modal -->
    <ham-modal
        *ngIf="(bexioImportStatus$ | async) === 'loading'"
        [title]="'bexio_importing_title' | i18next"
        [hideFooter]="true"
        [showCloseIcon]="false"
        size="sm">
        <div class="bexio-import-loading">
            <div class="bexio-import-loading__logos">
                <img src="/assets/hamIcons/bexio-logo.svg" class="bexio-import-loading__logo bexio-import-loading__logo--bexio" alt="Bexio" />
                <span class="bexio-import-loading__arrow">→</span>
                <img src="/assets/icons/aumico-logo-small.svg" class="bexio-import-loading__logo" alt="Aumico" />
            </div>
            <div class="bexio-import-loading__bar-wrap">
                <div class="bexio-import-loading__bar"></div>
            </div>
            <p class="bexio-import-loading__subtitle">{{ 'bexio_importing_subtitle' | i18next }}</p>
            <p class="bexio-import-loading__hint">{{ 'bexio_importing_hint' | i18next }}</p>
        </div>
    </ham-modal>

    <!-- Bexio import summary modal -->
    <ham-modal
        *ngIf="showBexioSummaryModal"
        [title]="'bexio_summary_title' | i18next"
        [saveText]="'bexio_summary_continue' | i18next"
        [showCancelButton]="true"
        [cancelText]="'bexio_summary_discard' | i18next"
        size="md"
        (save)="onBexioSummaryContinue()"
        (cancel)="onBexioSummaryDiscard()">
        <div class="bexio-import-summary">
            <div class="bexio-import-summary__body">
                <!-- Left: summary info -->
                <div class="bexio-import-summary__col">
                    <p class="bexio-import-summary__col-title">{{ 'bexio_summary_overview' | i18next }}</p>
                    <table class="bexio-import-summary__table">
                        <tr>
                            <td class="bexio-import-summary__label">{{ 'bexio_summary_company' | i18next }}</td>
                            <td>{{ bexioSummaryCompanyName }}</td>
                        </tr>
                        <tr>
                            <td class="bexio-import-summary__label">{{ 'bexio_summary_period' | i18next }}</td>
                            <td>{{ bexioSummaryResult?.period?.from | date:'dd.MM.yyyy' }} – {{ bexioSummaryResult?.period?.to | date:'dd.MM.yyyy' }}</td>
                        </tr>
                        <ng-container *ngIf="bexioSummaryResult?.previousYearAccounts != null && !noPreviousYearData && !isPreviousYearDataTakenFromPreviousBalanceAnnualReport">
                            <tr *ngIf="bexioSummaryPreviousYear">
                                <td class="bexio-import-summary__label">{{ 'bexio_summary_previous_period' | i18next }}</td>
                                <td>{{ bexioSummaryPreviousYear.start | date:'dd.MM.yyyy' }} – {{ bexioSummaryPreviousYear.end | date:'dd.MM.yyyy' }}</td>
                            </tr>
                        </ng-container>
                        <tr>
                            <td class="bexio-import-summary__label">{{ 'bexio_summary_accounts' | i18next }}</td>
                            <td>{{ bexioSummaryResult?.accountCount }}</td>
                        </tr>
                    </table>
                </div>

                <!-- Right: validation cards -->
                <div class="bexio-import-summary__col bexio-import-summary__col--validation">
                    <p class="bexio-import-summary__col-title">{{ 'bexio_summary_validation_title' | i18next }}</p>

                    <!-- Current year balance check -->
                    <div class="bexio-import-summary__check"
                        [class.bexio-import-summary__check--pass]="bexioSummaryResult?.validation?.currentYear?.balanced"
                        [class.bexio-import-summary__check--fail]="!bexioSummaryResult?.validation?.currentYear?.balanced">
                        <p class="bexio-import-summary__check-label">{{ 'bexio_summary_balance_check' | i18next }}</p>
                        <p class="bexio-import-summary__check-year">{{ 'bexio_summary_current_year' | i18next }}</p>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'bexio_summary_assets' | i18next }}</span>
                            <span>{{ bexioSummaryResult?.validation?.currentYear?.assets | number:'1.2-2' }}</span>
                        </div>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'bexio_summary_liabilities' | i18next }}</span>
                            <span>{{ bexioSummaryResult?.validation?.currentYear?.liabilities | number:'1.2-2' }}</span>
                        </div>
                    </div>

                    <!-- Previous year balance check (only if previous year data was fetched) -->
                    <div *ngIf="bexioSummaryResult?.validation?.previousYear != null"
                        class="bexio-import-summary__check"
                        [class.bexio-import-summary__check--pass]="bexioSummaryResult?.validation?.previousYear?.balanced"
                        [class.bexio-import-summary__check--fail]="!bexioSummaryResult?.validation?.previousYear?.balanced">
                        <p class="bexio-import-summary__check-label">{{ 'bexio_summary_balance_check' | i18next }}</p>
                        <p class="bexio-import-summary__check-year">{{ 'bexio_summary_previous_year' | i18next }}</p>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'bexio_summary_assets' | i18next }}</span>
                            <span>{{ bexioSummaryResult?.validation?.previousYear?.assets | number:'1.2-2' }}</span>
                        </div>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'bexio_summary_liabilities' | i18next }}</span>
                            <span>{{ bexioSummaryResult?.validation?.previousYear?.liabilities | number:'1.2-2' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ham-modal>

    <!-- D365 BC import loading modal -->
    <ham-modal
        *ngIf="(d365bcImportStatus$ | async) === 'loading'"
        [title]="'d365bc_importing_title' | i18next"
        [hideFooter]="true"
        [showCloseIcon]="false"
        size="sm">
        <div class="bexio-import-loading">
            <div class="bexio-import-loading__logos">
                <img src="/assets/hamIcons/d365bc-logo.svg" class="bexio-import-loading__logo bexio-import-loading__logo--d365bc" alt="D365 BC" />
                <span class="bexio-import-loading__arrow">→</span>
                <img src="/assets/icons/aumico-logo-small.svg" class="bexio-import-loading__logo" alt="aumico" />
            </div>
            <div class="bexio-import-loading__bar-wrap">
                <div class="bexio-import-loading__bar"></div>
            </div>
            <p class="bexio-import-loading__subtitle">{{ 'd365bc_importing_subtitle' | i18next }}</p>
            <p class="bexio-import-loading__hint">{{ 'd365bc_importing_hint' | i18next }}</p>
        </div>
    </ham-modal>

    <!-- D365 BC import summary modal -->
    <ham-modal
        *ngIf="showD365BcSummaryModal"
        [title]="'d365bc_summary_title' | i18next"
        [saveText]="'d365bc_summary_continue' | i18next"
        [showCancelButton]="true"
        [cancelText]="'d365bc_summary_discard' | i18next"
        size="md"
        (save)="onD365BcSummaryContinue()"
        (cancel)="onD365BcSummaryDiscard()">
        <div class="bexio-import-summary">
            <div class="bexio-import-summary__body">
                <div class="bexio-import-summary__col">
                    <p class="bexio-import-summary__col-title">{{ 'd365bc_summary_overview' | i18next }}</p>
                    <table class="bexio-import-summary__table">
                        <tr>
                            <td class="bexio-import-summary__label">{{ 'd365bc_summary_company' | i18next }}</td>
                            <td>{{ d365bcSummaryCompanyName }}</td>
                        </tr>
                        <tr>
                            <td class="bexio-import-summary__label">{{ 'd365bc_summary_period' | i18next }}</td>
                            <td>{{ d365bcSummaryResult?.period?.from | date:'dd.MM.yyyy' }} – {{ d365bcSummaryResult?.period?.to | date:'dd.MM.yyyy' }}</td>
                        </tr>
                        <ng-container *ngIf="d365bcSummaryResult?.previousYearAccounts != null && !noPreviousYearData && !isPreviousYearDataTakenFromPreviousBalanceAnnualReport">
                            <tr *ngIf="d365bcSyncedPreviousFiscalYear != null">
                                <td class="bexio-import-summary__label">{{ 'd365bc_summary_previous_period' | i18next }}</td>
                                <td>{{ d365bcSyncedPreviousFiscalYear?.startDate | date:'dd.MM.yyyy' }} – {{ d365bcSyncedPreviousFiscalYear?.endDate | date:'dd.MM.yyyy' }}</td>
                            </tr>
                        </ng-container>
                        <tr>
                            <td class="bexio-import-summary__label">{{ 'd365bc_summary_accounts' | i18next }}</td>
                            <td>{{ d365bcSummaryResult?.accountCount }}</td>
                        </tr>
                    </table>
                </div>

                <div class="bexio-import-summary__col bexio-import-summary__col--validation">
                    <p class="bexio-import-summary__col-title">{{ 'd365bc_summary_validation_title' | i18next }}</p>

                    <div class="bexio-import-summary__check"
                        [class.bexio-import-summary__check--pass]="d365bcSummaryResult?.validation?.currentYear?.balanced"
                        [class.bexio-import-summary__check--fail]="!d365bcSummaryResult?.validation?.currentYear?.balanced">
                        <p class="bexio-import-summary__check-label">{{ 'd365bc_summary_balance_check' | i18next }}</p>
                        <p class="bexio-import-summary__check-year">{{ 'd365bc_summary_current_year' | i18next }}</p>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'd365bc_summary_assets' | i18next }}</span>
                            <span>{{ d365bcSummaryResult?.validation?.currentYear?.assets | number:'1.2-2' }}</span>
                        </div>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'd365bc_summary_liabilities' | i18next }}</span>
                            <span>{{ d365bcSummaryResult?.validation?.currentYear?.liabilities | number:'1.2-2' }}</span>
                        </div>
                    </div>

                    <div *ngIf="d365bcSummaryResult?.validation?.previousYear != null"
                        class="bexio-import-summary__check"
                        [class.bexio-import-summary__check--pass]="d365bcSummaryResult?.validation?.previousYear?.balanced"
                        [class.bexio-import-summary__check--fail]="!d365bcSummaryResult?.validation?.previousYear?.balanced">
                        <p class="bexio-import-summary__check-label">{{ 'd365bc_summary_balance_check' | i18next }}</p>
                        <p class="bexio-import-summary__check-year">{{ 'd365bc_summary_previous_year' | i18next }}</p>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'd365bc_summary_assets' | i18next }}</span>
                            <span>{{ d365bcSummaryResult?.validation?.previousYear?.assets | number:'1.2-2' }}</span>
                        </div>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'd365bc_summary_liabilities' | i18next }}</span>
                            <span>{{ d365bcSummaryResult?.validation?.previousYear?.liabilities | number:'1.2-2' }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="d365bcUnmappableAccounts as unmappable"
                class="bexio-import-summary__warning"
                [innerHTML]="'d365bc_summary_unmappable_accounts' | i18next: {
                    count: unmappable.count,
                    accounts: unmappable.accountNumbers
                }"></div>
        </div>
    </ham-modal>

    <!-- D365 BC "manage in Organization Settings" modal (per-org vendor, not connectable here). -->
    <aumico-integration-go-to-admin-modal
        *ngIf="showD365bcOrgModal && d365bcVendorDef"
        [vendor]="d365bcVendorDef"
        [isAdmin]="(isAdmin$ | async) ?? false"
        (goToAdmin)="onD365bcGoToOrgSettings()"
        (closed)="onCloseD365bcOrgModal()">
    </aumico-integration-go-to-admin-modal>

    <!-- Abacus import loading modal -->
    <ham-modal
        *ngIf="(abacusImportStatus$ | async) === 'loading'"
        [title]="'abacus_importing_title' | i18next"
        [hideFooter]="true"
        [showCloseIcon]="false"
        size="sm">
        <div class="bexio-import-loading">
            <div class="bexio-import-loading__logos">
                <img src="/assets/hamIcons/generic-integration-logo.svg" class="bexio-import-loading__logo" alt="Abacus" />
                <span class="bexio-import-loading__arrow">→</span>
                <img src="/assets/icons/aumico-logo-small.svg" class="bexio-import-loading__logo" alt="aumico" />
            </div>
            <div class="bexio-import-loading__bar-wrap">
                <div class="bexio-import-loading__bar"></div>
            </div>
            <p class="bexio-import-loading__subtitle">{{ 'abacus_importing_subtitle' | i18next }}</p>
            <p class="bexio-import-loading__hint">{{ 'abacus_importing_hint' | i18next }}</p>
        </div>
    </ham-modal>

    <!-- Abacus import summary modal -->
    <ham-modal
        *ngIf="showAbacusSummaryModal"
        [title]="'abacus_summary_title' | i18next"
        [saveText]="'abacus_summary_continue' | i18next"
        [showCancelButton]="true"
        [cancelText]="'abacus_summary_discard' | i18next"
        size="md"
        (save)="onAbacusSummaryContinue()"
        (cancel)="onAbacusSummaryDiscard()">
        <div class="bexio-import-summary">
            <div class="bexio-import-summary__body">
                <div class="bexio-import-summary__col">
                    <p class="bexio-import-summary__col-title">{{ 'abacus_summary_overview' | i18next }}</p>
                    <table class="bexio-import-summary__table">
                        <tr>
                            <td class="bexio-import-summary__label">{{ 'abacus_summary_company' | i18next }}</td>
                            <td>{{ abacusSummaryCompanyName }}</td>
                        </tr>
                        <tr *ngIf="abacusSummaryPeriod != null">
                            <td class="bexio-import-summary__label">{{ 'abacus_summary_period' | i18next }}</td>
                            <td>{{ abacusSummaryPeriod.from | date:'dd.MM.yyyy' }} – {{ abacusSummaryPeriod.to | date:'dd.MM.yyyy' }}</td>
                        </tr>
                        <ng-container *ngIf="abacusSummaryResult?.previousYearAccounts != null && !noPreviousYearData && !isPreviousYearDataTakenFromPreviousBalanceAnnualReport">
                            <tr *ngIf="abacusSummaryPreviousPeriod != null">
                                <td class="bexio-import-summary__label">{{ 'abacus_summary_previous_period' | i18next }}</td>
                                <td>{{ abacusSummaryPreviousPeriod.from | date:'dd.MM.yyyy' }} – {{ abacusSummaryPreviousPeriod.to | date:'dd.MM.yyyy' }}</td>
                            </tr>
                        </ng-container>
                        <tr>
                            <td class="bexio-import-summary__label">{{ 'abacus_summary_accounts' | i18next }}</td>
                            <td>{{ abacusSummaryResult?.accountCount }}</td>
                        </tr>
                    </table>
                </div>

                <div class="bexio-import-summary__col bexio-import-summary__col--validation">
                    <p class="bexio-import-summary__col-title">{{ 'abacus_summary_validation_title' | i18next }}</p>

                    <div class="bexio-import-summary__check"
                        [class.bexio-import-summary__check--pass]="abacusSummaryResult?.validation?.currentYear?.balanced"
                        [class.bexio-import-summary__check--fail]="!abacusSummaryResult?.validation?.currentYear?.balanced">
                        <p class="bexio-import-summary__check-label">{{ 'abacus_summary_balance_check' | i18next }}</p>
                        <p class="bexio-import-summary__check-year">{{ 'abacus_summary_current_year' | i18next }}</p>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'abacus_summary_assets' | i18next }}</span>
                            <span>{{ abacusSummaryResult?.validation?.currentYear?.assets | number:'1.2-2' }}</span>
                        </div>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'abacus_summary_liabilities' | i18next }}</span>
                            <span>{{ abacusSummaryResult?.validation?.currentYear?.liabilities | number:'1.2-2' }}</span>
                        </div>
                    </div>

                    <div *ngIf="abacusSummaryResult?.validation?.previousYear != null"
                        class="bexio-import-summary__check"
                        [class.bexio-import-summary__check--pass]="abacusSummaryResult?.validation?.previousYear?.balanced"
                        [class.bexio-import-summary__check--fail]="!abacusSummaryResult?.validation?.previousYear?.balanced">
                        <p class="bexio-import-summary__check-label">{{ 'abacus_summary_balance_check' | i18next }}</p>
                        <p class="bexio-import-summary__check-year">{{ 'abacus_summary_previous_year' | i18next }}</p>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'abacus_summary_assets' | i18next }}</span>
                            <span>{{ abacusSummaryResult?.validation?.previousYear?.assets | number:'1.2-2' }}</span>
                        </div>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'abacus_summary_liabilities' | i18next }}</span>
                            <span>{{ abacusSummaryResult?.validation?.previousYear?.liabilities | number:'1.2-2' }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="abacusUnmappableAccounts as unmappable"
                class="bexio-import-summary__warning"
                [innerHTML]="'abacus_summary_unmappable_accounts' | i18next: {
                    count: unmappable.count,
                    accounts: unmappable.accountNumbers
                }"></div>
        </div>
    </ham-modal>

    <!-- Abacus "manage in Organization Settings" modal (per-org vendor, not connectable here). -->
    <aumico-integration-go-to-admin-modal
        *ngIf="showAbacusOrgModal && abacusVendorDef"
        [vendor]="abacusVendorDef"
        [isAdmin]="(isAdmin$ | async) ?? false"
        (goToAdmin)="onAbacusGoToOrgSettings()"
        (closed)="onCloseAbacusOrgModal()">
    </aumico-integration-go-to-admin-modal>

    <!-- Topal import loading modal -->
    <ham-modal
        *ngIf="(topalImportStatus$ | async) === 'loading'"
        [title]="'topal_importing_title' | i18next"
        [hideFooter]="true"
        [showCloseIcon]="false"
        size="sm">
        <div class="bexio-import-loading">
            <div class="bexio-import-loading__logos">
                <img src="/assets/hamIcons/topal-logo.png" class="bexio-import-loading__logo bexio-import-loading__logo--d365bc" alt="Topal" />
                <span class="bexio-import-loading__arrow">→</span>
                <img src="/assets/icons/aumico-logo-small.svg" class="bexio-import-loading__logo" alt="aumico" />
            </div>
            <div class="bexio-import-loading__bar-wrap">
                <div class="bexio-import-loading__bar"></div>
            </div>
            <p class="bexio-import-loading__subtitle">{{ 'topal_importing_subtitle' | i18next }}</p>
            <p class="bexio-import-loading__hint">{{ 'topal_importing_hint' | i18next }}</p>
        </div>
    </ham-modal>

    <!-- Topal import summary modal -->
    <ham-modal
        *ngIf="showTopalSummaryModal"
        [title]="'topal_summary_title' | i18next"
        [saveText]="'topal_summary_continue' | i18next"
        [showCancelButton]="true"
        [cancelText]="'topal_summary_discard' | i18next"
        size="md"
        (save)="onTopalSummaryContinue()"
        (cancel)="onTopalSummaryDiscard()">
        <div class="bexio-import-summary" data-testid="topal-summary">
            <div class="bexio-import-summary__body">
                <div class="bexio-import-summary__col">
                    <p class="bexio-import-summary__col-title">{{ 'topal_summary_overview' | i18next }}</p>
                    <table class="bexio-import-summary__table">
                        <tr>
                            <td class="bexio-import-summary__label">{{ 'topal_summary_company' | i18next }}</td>
                            <td data-testid="topal-summary-company">{{ topalSummaryCompanyName }}</td>
                        </tr>
                        <tr *ngIf="topalSummaryPeriod != null">
                            <td class="bexio-import-summary__label">{{ 'topal_summary_period' | i18next }}</td>
                            <td>{{ topalSummaryPeriod.from | date:'dd.MM.yyyy' }} – {{ topalSummaryPeriod.to | date:'dd.MM.yyyy' }}</td>
                        </tr>
                        <ng-container *ngIf="topalSummaryResult?.previousYearAccounts != null && !noPreviousYearData && !isPreviousYearDataTakenFromPreviousBalanceAnnualReport">
                            <tr *ngIf="topalSummaryPreviousPeriod != null">
                                <td class="bexio-import-summary__label">{{ 'topal_summary_previous_period' | i18next }}</td>
                                <td>{{ topalSummaryPreviousPeriod.from | date:'dd.MM.yyyy' }} – {{ topalSummaryPreviousPeriod.to | date:'dd.MM.yyyy' }}</td>
                            </tr>
                        </ng-container>
                        <tr>
                            <td class="bexio-import-summary__label">{{ 'topal_summary_accounts' | i18next }}</td>
                            <td data-testid="topal-summary-account-count">{{ topalSummaryResult?.accountCount }}</td>
                        </tr>
                    </table>
                </div>

                <div class="bexio-import-summary__col bexio-import-summary__col--validation">
                    <p class="bexio-import-summary__col-title">{{ 'topal_summary_validation_title' | i18next }}</p>

                    <div class="bexio-import-summary__check"
                        data-testid="topal-summary-balance-check-current"
                        [attr.data-balanced]="topalSummaryResult?.validation?.currentYear?.balanced"
                        [class.bexio-import-summary__check--pass]="topalSummaryResult?.validation?.currentYear?.balanced"
                        [class.bexio-import-summary__check--fail]="!topalSummaryResult?.validation?.currentYear?.balanced">
                        <p class="bexio-import-summary__check-label">{{ 'topal_summary_balance_check' | i18next }}</p>
                        <p class="bexio-import-summary__check-year">{{ 'topal_summary_current_year' | i18next }}</p>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'topal_summary_assets' | i18next }}</span>
                            <span>{{ topalSummaryResult?.validation?.currentYear?.assets | number:'1.2-2' }}</span>
                        </div>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'topal_summary_liabilities' | i18next }}</span>
                            <span>{{ topalSummaryResult?.validation?.currentYear?.liabilities | number:'1.2-2' }}</span>
                        </div>
                    </div>

                    <div *ngIf="topalSummaryResult?.validation?.previousYear != null"
                        class="bexio-import-summary__check"
                        [class.bexio-import-summary__check--pass]="topalSummaryResult?.validation?.previousYear?.balanced"
                        [class.bexio-import-summary__check--fail]="!topalSummaryResult?.validation?.previousYear?.balanced">
                        <p class="bexio-import-summary__check-label">{{ 'topal_summary_balance_check' | i18next }}</p>
                        <p class="bexio-import-summary__check-year">{{ 'topal_summary_previous_year' | i18next }}</p>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'topal_summary_assets' | i18next }}</span>
                            <span>{{ topalSummaryResult?.validation?.previousYear?.assets | number:'1.2-2' }}</span>
                        </div>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'topal_summary_liabilities' | i18next }}</span>
                            <span>{{ topalSummaryResult?.validation?.previousYear?.liabilities | number:'1.2-2' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ham-modal>

    <!-- Topal "manage in Organization Settings" modal (per-org vendor, not connectable here). -->
    <aumico-integration-go-to-admin-modal
        *ngIf="showTopalOrgModal && topalVendorDef"
        [vendor]="topalVendorDef"
        [isAdmin]="(isAdmin$ | async) ?? false"
        (goToAdmin)="onTopalGoToOrgSettings()"
        (closed)="onCloseTopalOrgModal()">
    </aumico-integration-go-to-admin-modal>

    <!-- Accounto import loading modal -->
    <ham-modal
        *ngIf="(accountoImportStatus$ | async) === 'loading'"
        [title]="'accounto_importing_title' | i18next"
        [hideFooter]="true"
        [showCloseIcon]="false"
        size="sm">
        <div class="bexio-import-loading">
            <div class="bexio-import-loading__logos">
                <img src="/assets/hamIcons/accounto-logo.png" class="bexio-import-loading__logo bexio-import-loading__logo--accounto" alt="Accounto" />
                <span class="bexio-import-loading__arrow">→</span>
                <img src="/assets/icons/aumico-logo-small.svg" class="bexio-import-loading__logo" alt="aumico" />
            </div>
            <div class="bexio-import-loading__bar-wrap">
                <div class="bexio-import-loading__bar"></div>
            </div>
            <p class="bexio-import-loading__subtitle">{{ 'accounto_importing_subtitle' | i18next }}</p>
            <p class="bexio-import-loading__hint">{{ 'accounto_importing_hint' | i18next }}</p>
        </div>
    </ham-modal>

    <!-- Accounto import summary modal -->
    <ham-modal
        *ngIf="showAccountoSummaryModal"
        [title]="'accounto_summary_title' | i18next"
        [saveText]="'accounto_summary_continue' | i18next"
        [showCancelButton]="true"
        [cancelText]="'accounto_summary_discard' | i18next"
        size="md"
        (save)="onAccountoSummaryContinue()"
        (cancel)="onAccountoSummaryDiscard()">
        <div class="bexio-import-summary" data-testid="accounto-summary">
            <div class="bexio-import-summary__body">
                <div class="bexio-import-summary__col">
                    <p class="bexio-import-summary__col-title">{{ 'accounto_summary_overview' | i18next }}</p>
                    <table class="bexio-import-summary__table">
                        <tr>
                            <td class="bexio-import-summary__label">{{ 'accounto_summary_company' | i18next }}</td>
                            <td data-testid="accounto-summary-company">{{ accountoSummaryCompanyName }}</td>
                        </tr>
                        <tr *ngIf="accountoSummaryPeriod != null">
                            <td class="bexio-import-summary__label">{{ 'accounto_summary_period' | i18next }}</td>
                            <td>{{ accountoSummaryPeriod.from | date:'dd.MM.yyyy' }} – {{ accountoSummaryPeriod.to | date:'dd.MM.yyyy' }}</td>
                        </tr>
                        <ng-container *ngIf="accountoSummaryResult?.previousYearAccounts != null && !noPreviousYearData && !isPreviousYearDataTakenFromPreviousBalanceAnnualReport">
                            <tr *ngIf="accountoSummaryPreviousPeriod != null">
                                <td class="bexio-import-summary__label">{{ 'accounto_summary_previous_period' | i18next }}</td>
                                <td>{{ accountoSummaryPreviousPeriod.from | date:'dd.MM.yyyy' }} – {{ accountoSummaryPreviousPeriod.to | date:'dd.MM.yyyy' }}</td>
                            </tr>
                        </ng-container>
                        <tr>
                            <td class="bexio-import-summary__label">{{ 'accounto_summary_accounts' | i18next }}</td>
                            <td data-testid="accounto-summary-account-count">{{ accountoSummaryResult?.accountCount }}</td>
                        </tr>
                    </table>
                </div>

                <div class="bexio-import-summary__col bexio-import-summary__col--validation">
                    <p class="bexio-import-summary__col-title">{{ 'accounto_summary_validation_title' | i18next }}</p>

                    <div class="bexio-import-summary__check"
                        data-testid="accounto-summary-balance-check-current"
                        [attr.data-balanced]="accountoSummaryResult?.validation?.currentYear?.balanced"
                        [class.bexio-import-summary__check--pass]="accountoSummaryResult?.validation?.currentYear?.balanced"
                        [class.bexio-import-summary__check--fail]="!accountoSummaryResult?.validation?.currentYear?.balanced">
                        <p class="bexio-import-summary__check-label">{{ 'accounto_summary_balance_check' | i18next }}</p>
                        <p class="bexio-import-summary__check-year">{{ 'accounto_summary_current_year' | i18next }}</p>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'accounto_summary_assets' | i18next }}</span>
                            <span>{{ accountoSummaryResult?.validation?.currentYear?.assets | number:'1.2-2' }}</span>
                        </div>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'accounto_summary_liabilities' | i18next }}</span>
                            <span>{{ accountoSummaryResult?.validation?.currentYear?.liabilities | number:'1.2-2' }}</span>
                        </div>
                    </div>

                    <div *ngIf="accountoSummaryResult?.validation?.previousYear != null"
                        class="bexio-import-summary__check"
                        [class.bexio-import-summary__check--pass]="accountoSummaryResult?.validation?.previousYear?.balanced"
                        [class.bexio-import-summary__check--fail]="!accountoSummaryResult?.validation?.previousYear?.balanced">
                        <p class="bexio-import-summary__check-label">{{ 'accounto_summary_balance_check' | i18next }}</p>
                        <p class="bexio-import-summary__check-year">{{ 'accounto_summary_previous_year' | i18next }}</p>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'accounto_summary_assets' | i18next }}</span>
                            <span>{{ accountoSummaryResult?.validation?.previousYear?.assets | number:'1.2-2' }}</span>
                        </div>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'accounto_summary_liabilities' | i18next }}</span>
                            <span>{{ accountoSummaryResult?.validation?.previousYear?.liabilities | number:'1.2-2' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ham-modal>

    <!-- Accounto "manage in Organization Settings" modal (per-org vendor, not connectable here). -->
    <aumico-integration-go-to-admin-modal
        *ngIf="showAccountoOrgModal && accountoVendorDef"
        [vendor]="accountoVendorDef"
        [isAdmin]="(isAdmin$ | async) ?? false"
        (goToAdmin)="onAccountoGoToOrgSettings()"
        (closed)="onCloseAccountoOrgModal()">
    </aumico-integration-go-to-admin-modal>

    <!-- Proffix import loading modal -->
    <ham-modal
        *ngIf="(proffixImportStatus$ | async) === 'loading'"
        [title]="'proffix_importing_title' | i18next"
        [hideFooter]="true"
        [showCloseIcon]="false"
        size="sm">
        <div class="bexio-import-loading">
            <div class="bexio-import-loading__logos">
                <img src="/assets/hamIcons/proffix-logo.png" class="bexio-import-loading__logo bexio-import-loading__logo--d365bc" alt="PROFFIX" />
                <span class="bexio-import-loading__arrow">→</span>
                <img src="/assets/icons/aumico-logo-small.svg" class="bexio-import-loading__logo" alt="aumico" />
            </div>
            <div class="bexio-import-loading__bar-wrap">
                <div class="bexio-import-loading__bar"></div>
            </div>
            <p class="bexio-import-loading__subtitle">{{ 'proffix_importing_subtitle' | i18next }}</p>
            <p class="bexio-import-loading__hint">{{ 'proffix_importing_hint' | i18next }}</p>
        </div>
    </ham-modal>

    <!-- Proffix import summary modal -->
    <ham-modal
        *ngIf="showProffixSummaryModal"
        [title]="'proffix_summary_title' | i18next"
        [saveText]="'proffix_summary_continue' | i18next"
        [showCancelButton]="true"
        [cancelText]="'proffix_summary_discard' | i18next"
        size="md"
        (save)="onProffixSummaryContinue()"
        (cancel)="onProffixSummaryDiscard()">
        <div class="bexio-import-summary" data-testid="proffix-summary">
            <div class="bexio-import-summary__body">
                <div class="bexio-import-summary__col">
                    <p class="bexio-import-summary__col-title">{{ 'proffix_summary_overview' | i18next }}</p>
                    <table class="bexio-import-summary__table">
                        <tr>
                            <td class="bexio-import-summary__label">{{ 'proffix_summary_company' | i18next }}</td>
                            <td data-testid="proffix-summary-company">{{ proffixSummaryCompanyName }}</td>
                        </tr>
                        <tr *ngIf="proffixSummaryPeriod != null">
                            <td class="bexio-import-summary__label">{{ 'proffix_summary_period' | i18next }}</td>
                            <td>{{ proffixSummaryPeriod.from | date:'dd.MM.yyyy' }} – {{ proffixSummaryPeriod.to | date:'dd.MM.yyyy' }}</td>
                        </tr>
                        <ng-container *ngIf="proffixSummaryResult?.previousYearAccounts != null && !noPreviousYearData && !isPreviousYearDataTakenFromPreviousBalanceAnnualReport">
                            <tr *ngIf="proffixSummaryPreviousPeriod != null">
                                <td class="bexio-import-summary__label">{{ 'proffix_summary_previous_period' | i18next }}</td>
                                <td>{{ proffixSummaryPreviousPeriod.from | date:'dd.MM.yyyy' }} – {{ proffixSummaryPreviousPeriod.to | date:'dd.MM.yyyy' }}</td>
                            </tr>
                        </ng-container>
                        <tr>
                            <td class="bexio-import-summary__label">{{ 'proffix_summary_accounts' | i18next }}</td>
                            <td data-testid="proffix-summary-account-count">{{ proffixSummaryResult?.accountCount }}</td>
                        </tr>
                    </table>
                </div>

                <div class="bexio-import-summary__col bexio-import-summary__col--validation">
                    <p class="bexio-import-summary__col-title">{{ 'proffix_summary_validation_title' | i18next }}</p>

                    <div class="bexio-import-summary__check"
                        data-testid="proffix-summary-balance-check-current"
                        [attr.data-balanced]="proffixSummaryResult?.validation?.currentYear?.balanced"
                        [class.bexio-import-summary__check--pass]="proffixSummaryResult?.validation?.currentYear?.balanced"
                        [class.bexio-import-summary__check--fail]="!proffixSummaryResult?.validation?.currentYear?.balanced">
                        <p class="bexio-import-summary__check-label">{{ 'proffix_summary_balance_check' | i18next }}</p>
                        <p class="bexio-import-summary__check-year">{{ 'proffix_summary_current_year' | i18next }}</p>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'proffix_summary_assets' | i18next }}</span>
                            <span>{{ proffixSummaryResult?.validation?.currentYear?.assets | number:'1.2-2' }}</span>
                        </div>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'proffix_summary_liabilities' | i18next }}</span>
                            <span>{{ proffixSummaryResult?.validation?.currentYear?.liabilities | number:'1.2-2' }}</span>
                        </div>
                    </div>

                    <div *ngIf="proffixSummaryResult?.validation?.previousYear != null"
                        class="bexio-import-summary__check"
                        [class.bexio-import-summary__check--pass]="proffixSummaryResult?.validation?.previousYear?.balanced"
                        [class.bexio-import-summary__check--fail]="!proffixSummaryResult?.validation?.previousYear?.balanced">
                        <p class="bexio-import-summary__check-label">{{ 'proffix_summary_balance_check' | i18next }}</p>
                        <p class="bexio-import-summary__check-year">{{ 'proffix_summary_previous_year' | i18next }}</p>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'proffix_summary_assets' | i18next }}</span>
                            <span>{{ proffixSummaryResult?.validation?.previousYear?.assets | number:'1.2-2' }}</span>
                        </div>
                        <div class="bexio-import-summary__check-row">
                            <span>{{ 'proffix_summary_liabilities' | i18next }}</span>
                            <span>{{ proffixSummaryResult?.validation?.previousYear?.liabilities | number:'1.2-2' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ham-modal>

    <!-- Proffix "manage in Organization Settings" modal (per-org vendor, not connectable here). -->
    <aumico-integration-go-to-admin-modal
        *ngIf="showProffixOrgModal && proffixVendorDef"
        [vendor]="proffixVendorDef"
        [isAdmin]="(isAdmin$ | async) ?? false"
        (goToAdmin)="onProffixGoToOrgSettings()"
        (closed)="onCloseProffixOrgModal()">
    </aumico-integration-go-to-admin-modal>
</ng-container>
<ng-template #footerTemplate>
    <aum-action-bar-pure
        [extraActionButtons]="footerExtraButtonActions"
        nextButtonPrefixText="{{ nextStepPrefix | i18next }}"
        nextButtonText="{{ mappingStepLabel | i18next }}"
        [nextButtonAction]="proceedButtonClicked"
        nextButtonRouterLink="../{{ mappingStepPath }}"
        [nextButtonDisabled]="disableProceedButton"
        backButtonPrefixText="{{ previousStepPrefix | i18next }}"
        backButtonText="{{ previousStepLabel | i18next }}"
        backButtonRouterLink="../../{{ previousStepPath }}"
        [backButtonIcon]="previousStepIcon"
    ></aum-action-bar-pure>
</ng-template>
